import {
  fetchMentorClassLearningGoals,
  fetchMentorClassLearningGoalsSubject,
} from "classroom/api/teacher";
import type {
  ClusterStudentResource,
  MyStudentLearningObjectiveResource,
} from "api/generated";
import { defineStore } from "pinia";

export const useClassroomMentorClassLearningGoalsStore = defineStore(
  "classroomMentorClassLearningGoals",
  () => {
    const loadStudents = async (
      mentorClass: string,
      periodId: number,
      signal?: AbortSignal,
    ): Promise<MyStudentLearningObjectiveResource[]> => {
      return fetchMentorClassLearningGoals(mentorClass, periodId, signal);
    };

    const loadSubjectClusters = async (
      studentId: number,
      scheduleId: number,
      periodId: number,
      signal?: AbortSignal,
    ): Promise<ClusterStudentResource[]> => {
      return fetchMentorClassLearningGoalsSubject(
        studentId,
        scheduleId,
        periodId,
        signal,
      );
    };

    return { loadStudents, loadSubjectClusters };
  },
);
